<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" id="pg3sec1" title="Bodymatter">
<figure>
<p class="imaget"><span class="right_1" epub:type="pagebreak" id="page_3" title="3"><img alt="" height="494" src="images/f0003-01.jpg" width="566"/></span></p>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Intsec2.vue?0d759b5d